import FluxUtils from 'flux/utils';
import Immutable from 'immutable';

import type { ActionType } from 'sharedreact/actions/generic/actions';
import AppDispatcher from 'sharedreact/dispatcher/AppDispatcher';

import UsageConstants from 'workspaces/launcher/constants/UsageConstants';

const Content: {
  didOptIn: boolean,
  userName: string,
  testEnv: boolean
} = {
  didOptIn: false,
  userName: '',
  testEnv: false
};

class State extends Immutable.Record(Content) {
}

class UsageStore extends FluxUtils.ReduceStore<State, ActionType> {
  constructor () {
    super(AppDispatcher);
  }

  override getInitialState (): State {
    return new State();
  }

  override reduce (state: State, action: ActionType): State {
    switch (action.actionType) {
      case UsageConstants.OPT_IN_SUCCESS:
      case UsageConstants.GET_SUCCESS:
      case UsageConstants.OPT_OUT_SUCCESS: {
        state = state
          .set('didOptIn', action.didOptIn)
          .set('userName', action.userName)
          .set('testEnv', action.testEnv);
        break;
      }
    }
    
    return state;
  }
}

export default new UsageStore();
